import React from "react";
import { Link } from "react-router-dom";
import { registerUser } from "../../../features/userSlice";
import { useDispatch } from "react-redux";

const RegistrationPage = () => {
  const dispatch = useDispatch();
 const [message, setMessage] = React.useState(null);
const [inputValues, setInputValues] = React.useState({
  username: "",
  email: "",
  password: ""
});

const submitRegistration = async (e) => {
  e.preventDefault();

  // Show checking...
  setMessage(
    <div className="border border-blue-600 px-4 py-1 rounded mb-4 text-blue-600 bg-blue-50">
      <p className="text-sm">Checking...</p>
    </div>
  );

  // Delay for validation
  setTimeout(() => {
    const errors = [];

    if (!inputValues.username.trim()) {
      errors.push("Username is required");
    }
    if (!inputValues.email.trim()) {
      errors.push("Email is required");
    }
    if (!inputValues.password.trim()) {
      errors.push("Password is required");
    }

    // If there are errors → show list
    if (errors.length > 0) {
      setMessage(
        <div className="border border-red-600 px-4 py-2 rounded mb-4 text-red-600 bg-red-50">
          <ul className="list-disc pl-5 text-sm">
            {errors.map((err, index) => (
              <li key={index}>{err}</li>
            ))}
          </ul>
        </div>
      );
      return;
    }

     

    const data = dispatch(
      registerUser({
        username: inputValues.username,
        email: inputValues.email,
        password: inputValues.password,
      })
    );
    data.then((res) => {
      if (res.type === "userAuth/registerUser/fulfilled") {
        setMessage(
          <div className="border border-green-600 px-4 py-1 rounded mb-4 text-green-600 bg-green-50">
            <p className="text-sm">Registration successful! Redirecting...</p>
          </div>
        );
        setTimeout(() => {
          window.location.href = "/login";
        }, 2000);
      }
      if (res.type === "userAuth/registerUser/rejected") {
        setMessage(
          <div className="border border-red-600 px-4 py-1 rounded mb-4 text-red-600 bg-red-50">
            <p className="text-sm">
              {res.payload || "Registration failed. Please try again."}
            </p>
          </div>
        );
      }
    });


  }, 1000);
};


  return (
    // Main container ensuring min-height covers the full viewport (100vh)
    <div className="flex flex-col min-h-screen bg-gray-50 font-sans">
      {/* Header Section */}
      <header className="py-4 px-8 border-b border-gray-200 bg-white shadow-sm">
        <div className="max-w-7xl mx-auto">
          {/* Logo Placeholder */}
          <div className="text-2xl font-bold text-indigo-600">
            SONGZUG - Social Network
          </div>
        </div>
      </header>

      {/* Main Content Section */}
      <main className="flex-grow flex items-center justify-center p-8">
        <div className="max-w-7xl w-full flex flex-col md:flex-row items-center justify-between gap-12">
          {/* Left Side: Illustration and Core Message */}
          <div className="md:w-1/2 flex flex-col items-center md:items-start text-center md:text-left">
            <h1 className="text-5xl font-extrabold text-gray-900 mb-4 leading-tight">
              Create Your Free Account
            </h1>
            <p className="text-xl text-gray-600 mb-8">
              Fast, secure, and ready to connect you with the world.
            </p>

            {/* Illustration Placeholder (Left side of the registration box) */}
            <div className="w-full max-w-md h-64 bg-indigo-100 rounded-lg shadow-xl flex items-center justify-center border-4 border-indigo-200">
              <span className="text-indigo-600 text-lg font-semibold">
                [Image of a Sign Up Illustration]
              </span>
            </div>
          </div>

          {/* Right Side: Registration Form */}
          <div className="md:w-1/3 w-full max-w-sm bg-white p-8 rounded-xl shadow-2xl border border-gray-200">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
              Sign Up Now
            </h2>
            {message}
            <form className="space-y-4" onSubmit={submitRegistration}>
              {/* Full Name Input */}
              <div>
                <label htmlFor="username" className="sr-only">
                  Full Name
                </label>
                <input
                  id="username"
                  name="username"
                  type="text"
                  value={inputValues.username}
                  onChange={(e) => setInputValues({ ...inputValues, username: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500 text-gray-900"
                  placeholder="Username"
                />
              </div>

              {/* Email Input */}
              <div>
                <label htmlFor="email" className="sr-only">
                  Email Address
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={inputValues.email}
                  onChange={(e) => setInputValues({ ...inputValues, email: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500 text-gray-900"
                  placeholder="Email Address"
                />
              </div>

              {/* Password Input */}
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  value={inputValues.password}
                  onChange={(e) => setInputValues({ ...inputValues, password: e.target.value })}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500 placeholder-gray-500 text-gray-900"
                  placeholder="Password (min. 8 characters)"
                />
              </div>

              {/* Terms Checkbox */}
              <div className="flex items-center">
                <input
                  id="terms"
                  name="terms"
                  type="checkbox"
                  required
                  className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                />
                <label
                  htmlFor="terms"
                  className="ml-2 block text-sm text-gray-900"
                >
                  I agree to the{" "}
                  <a
                    href="#"
                    className="font-medium text-indigo-600 hover:text-indigo-500"
                  >
                    Terms and Privacy Policy
                  </a>
                </label>
              </div>

              {/* Registration Button */}
              <button
                type="submit"
                className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-lg font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition duration-150"
              >
                Register
              </button>
            </form>

            {/* Already Have Account */}
            <div className="mt-6 text-center">
              <p className="text-sm text-gray-500">
                Already have an account?
                <Link
                  to="/login"
                  className="font-medium text-indigo-600 hover:text-indigo-500 ml-1"
                >
                  Log In
                </Link>
              </p>
            </div>
          </div>
        </div>
      </main>

      {/* Footer Section */}
      <footer className="py-6 px-8 bg-white border-t border-gray-200">
        <div className="max-w-7xl mx-auto text-center text-sm text-gray-500">
          <div className="space-x-4">
            <a href="#" className="hover:text-indigo-600 transition">
              Privacy Policy
            </a>
            <span className="text-gray-300">|</span>
            <a href="#" className="hover:text-indigo-600 transition">
              Terms of Service
            </a>
            <span className="text-gray-300">|</span>
            <a href="#" className="hover:text-indigo-600 transition">
              Contact
            </a>
            <span className="text-gray-300">|</span>
            <a href="#" className="hover:text-indigo-600 transition">
              Help Center
            </a>
          </div>
          <p className="mt-3">
            &copy; {new Date().getFullYear()} SocialApp. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default RegistrationPage;
